export const conditionTH = {
    header: {
        h1: "เงื่อนไขการใช้งาน​"
    },
    title: {
        t1: "1. คำจำกัดความ"

    },
    subtitle: {
        t1: {
            s1: `1.1.
            เว้นแต่ข้อความในนโยบายความเป็นส่วนตัวฉบับนี้กำหนดไว้เป็นประการอื่น
            ให้คำและข้อความต่าง ๆ ดังต่อไปนี้
            ในนโยบายความเป็นส่วนตัวฉบับนี้
            มีความหมายดังนี้`
        }
    },
    detail: {
        h1: `บริษัท โอคอนเทค จำกัด (“บริษัทฯ”)
        เล็งเห็นถึงความสำคัญของการคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้บริการ
        เราทราบดีว่าผู้ใช้บริการเป็นห่วงและให้ความสำคัญกับวิธีการที่ข้อมูลของผู้ใช้บริการจะถูกเก็บรวบรวม
        ใช้ เปิดเผย และ
        ส่งหรือโอนไปยังต่างประเทศ
        ซึ่งเราจะนำข้อมูลที่ผู้ใช้บริการแบ่งปันให้กับเรานั้นไปใช้เพื่อการให้บริการเพื่ออำนวยความสะดวกแก่ผู้ใช้บริการเป็นสำคัญ
        บริษัทฯ
        ซาบซึ้งในความไว้วางใจของผู้ใช้บริการและเราจะดูแลข้อมูลส่วนบุคคลของผู้ใช้บริการด้วย
        ความระมัดระวังและอย่างสมเหตุสมผล
        ในการมอบประสบการณ์และการให้บริการอย่างดีที่สุดให้แก่ผู้ใช้บริการ
        นโยบายความเป็นส่วนตัวฉบับนี้
        (“นโยบายความเป็นส่วนตัว”)
        มีวัตถุประสงค์เพื่อขอความยินยอม
        และแจ้งวิธีการแก่ผู้ใช้บริการ
        (ตามที่จะได้นิยามต่อไป) ที่บริษัทฯ
        จะเก็บรวบรวม ใช้ และเปิดเผย
        “ข้อมูลส่วนบุคคล”
        (ตามที่จะได้นิยามต่อไป)
        ในส่วนที่เกี่ยวกับการให้บริการทั้งหมดที่เกี่ยวข้องของบริษัทฯ
        (ตามที่จะได้นิยามต่อไป)ภายใต้บทบัญญัติของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
        พ.ศ. 2562 (และที่แก้ไขเพิ่มเติม)
        รวมทั้งประกาศที่เกี่ยวข้อง
        (“กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล”)
        ผู้ใช้บริการโปรดอ่านนโยบายความเป็นส่วนตัวฉบับนี้
        เพื่อรับทราบและทำความเข้าใจในวัตถุประสงค์ที่บริษัทฯ
        ได้เก็บรวบรวม ใช้
        และเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้บริการ`,
        t1:{
            s1: `<b>“บริษัทฯ”</b> หมายถึง บริษัท
            โอคอนเทค จำกัด<br />
            <b>“ข้อมูลส่วนบุคคล”</b> หมายถึง
            ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถ
            ระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม
            แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ
            <br />
            <b>“บริการ”</b> หมายถึง
            บริการทั้งหมดที่เกี่ยวข้องของบริษัทฯ
            ไม่ว่าจะมีการลงทะเบียนเพื่อเปิดบัญชีหรือไม่ก็ตาม
            และไม่ว่าจะมีค่าตอบแทนหรือไม่ก็ตาม
            ซึ่งรวมถึงการให้บริการระบบการติดตามการรับส่งนักเรียน
            ระบบตรวจสอบการเข้าและออกโรงเรืยน
            ระบบงานสนับสนุนทางวิชาการ
            ระบบสำหรับร้านค้าและสหกรณ์ภายในโรงเรียน`
        } 
    }
}

export const conditionEN = {
    header: {
        h1: "Terms of Use"
    },
    title: {
        t1: "1. คำจำกัดความ"

    },
    subtitle: {
        t1: {
            s1: `1.1.
            เว้นแต่ข้อความในนโยบายความเป็นส่วนตัวฉบับนี้กำหนดไว้เป็นประการอื่น
            ให้คำและข้อความต่าง ๆ ดังต่อไปนี้
            ในนโยบายความเป็นส่วนตัวฉบับนี้
            มีความหมายดังนี้`
        }
    },
    detail: {
        h1: `บริษัท โอคอนเทค จำกัด (“บริษัทฯ”)
        เล็งเห็นถึงความสำคัญของการคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้บริการ
        เราทราบดีว่าผู้ใช้บริการเป็นห่วงและให้ความสำคัญกับวิธีการที่ข้อมูลของผู้ใช้บริการจะถูกเก็บรวบรวม
        ใช้ เปิดเผย และ
        ส่งหรือโอนไปยังต่างประเทศ
        ซึ่งเราจะนำข้อมูลที่ผู้ใช้บริการแบ่งปันให้กับเรานั้นไปใช้เพื่อการให้บริการเพื่ออำนวยความสะดวกแก่ผู้ใช้บริการเป็นสำคัญ
        บริษัทฯ
        ซาบซึ้งในความไว้วางใจของผู้ใช้บริการและเราจะดูแลข้อมูลส่วนบุคคลของผู้ใช้บริการด้วย
        ความระมัดระวังและอย่างสมเหตุสมผล
        ในการมอบประสบการณ์และการให้บริการอย่างดีที่สุดให้แก่ผู้ใช้บริการ
        นโยบายความเป็นส่วนตัวฉบับนี้
        (“นโยบายความเป็นส่วนตัว”)
        มีวัตถุประสงค์เพื่อขอความยินยอม
        และแจ้งวิธีการแก่ผู้ใช้บริการ
        (ตามที่จะได้นิยามต่อไป) ที่บริษัทฯ
        จะเก็บรวบรวม ใช้ และเปิดเผย
        “ข้อมูลส่วนบุคคล”
        (ตามที่จะได้นิยามต่อไป)
        ในส่วนที่เกี่ยวกับการให้บริการทั้งหมดที่เกี่ยวข้องของบริษัทฯ
        (ตามที่จะได้นิยามต่อไป)ภายใต้บทบัญญัติของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
        พ.ศ. 2562 (และที่แก้ไขเพิ่มเติม)
        รวมทั้งประกาศที่เกี่ยวข้อง
        (“กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล”)
        ผู้ใช้บริการโปรดอ่านนโยบายความเป็นส่วนตัวฉบับนี้
        เพื่อรับทราบและทำความเข้าใจในวัตถุประสงค์ที่บริษัทฯ
        ได้เก็บรวบรวม ใช้
        และเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้บริการ`,
        t1:{
            s1: `<b>“บริษัทฯ”</b> หมายถึง บริษัท
            โอคอนเทค จำกัด<br />
            <b>“ข้อมูลส่วนบุคคล”</b> หมายถึง
            ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถ
            ระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม
            แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ
            <br />
            <b>“บริการ”</b> หมายถึง
            บริการทั้งหมดที่เกี่ยวข้องของบริษัทฯ
            ไม่ว่าจะมีการลงทะเบียนเพื่อเปิดบัญชีหรือไม่ก็ตาม
            และไม่ว่าจะมีค่าตอบแทนหรือไม่ก็ตาม
            ซึ่งรวมถึงการให้บริการระบบการติดตามการรับส่งนักเรียน
            ระบบตรวจสอบการเข้าและออกโรงเรืยน
            ระบบงานสนับสนุนทางวิชาการ
            ระบบสำหรับร้านค้าและสหกรณ์ภายในโรงเรียน`
        } 
    }
}